import type { ColorSystemOptions } from '@mui/material/styles';

import { colors } from '../tokens';

export const lightScheme: ColorSystemOptions = {
  palette: {
    primary: {
      main: colors.green[500],
    },
    error: { main: colors.red[600] },
    warning: { main: colors.warning[600] },
    info: { main: colors.green[500] },
    success: {
      light: colors.green[50],
      main: colors.green[600],
    },
    background: {
      default: colors.gray[50],
      paper: colors.common.white,
      bgSecondaryAlt: colors.gray[50],
      bgSecondarySubtle: '#F9FAFC',
    },
    text: {
      primary: colors.black[950],
      secondary: colors.black[700],
      disabled: colors.black[300],
      primaryOnBrand: colors.common.white,
      secondaryHover: colors.black[800],
      secondaryOnBrand: colors.gray[200],
      tertiary: colors.black[600],
      tertiaryHover: colors.black[700],
      tertiaryOnBrand: colors.green[200],
      quaternary: colors.gray[500],
      quaternaryOnBrand: colors.green[300],
      placeholder: colors.gray[300],
      placeholderSubtle: colors.black[300],
      brandPrimary: colors.green[500],
      brandSecondary: colors.green[600],
      brandSecondaryHover: colors.green[800],
      brandTertiary: colors.green[700],
      brandTertiaryAlt: colors.green[600],
      errorPrimary: colors.red[600],
      warningPrimary: colors.warning[600],
      successPrimary: colors.success[600],
    },
    divider: colors.gray[200],
    teal: colors.teal,
    black: colors.black,
    green: colors.green,
    gray: colors.gray,
    grayTrue: colors.grayTrue,
    red: colors.red,
  },
};
